import React from 'react';
import {Layout, Menu, Icon} from 'antd';
import LoadMoreList from "../compoments/LoadMoreList";


const {Header, Content, Footer, Sider} = Layout;
class IndexPage extends React.Component {
    render() {
        return (
            <Layout>
                <Header style={{position: 'fixed', zIndex: 1, width: '100%', background: "white"}}>
                    个人技术分享
                </Header>
                <Content style={{padding: '0 50px', marginTop: 64}}>
                    <LoadMoreList/>
                    <div style={{textAlign: 'center',bottom:"0",width:"100%",padding:"8px 0", marginTop:'50px',color:"#a9a9a9"}}><a href="https://beian.miit.gov.cn/">蜀ICP备18033988号</a></div>
                </Content>

            </Layout>
        )
    }
}

export default IndexPage;
